export const downloadFile = async (fileUrl: string, fileName?: string) => {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.target = '_blank';
  // Prevent security vulnerabilities
  // A malicious or compromised document URL could then redirect the original window (reverse tabnabbing).
  // Set rel="noopener noreferrer" (or drop target) to close that gap.
  link.rel = 'noopener noreferrer';
  if (fileName) {
    link.download = fileName;
  } else {
    link.download = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
  }
  document.body.appendChild(link);
  // Safari issue can not download files without a small delay
  await new Promise(resolve => setTimeout(resolve, 500));
  link.click();
  document.body.removeChild(link);
};

/**
 * Some files need to be fetched as blob first before downloading (e.g. GEOJSON files)
 * Otherwise chrome and other browsers might try to open them instead of downloading
 */
export const downloadFileWithBlob = async (fileUrl: string, fileName?: string) => {
  const fileResponse = await fetch(fileUrl);
  const blob = await fileResponse.blob();
  const url = window.URL.createObjectURL(blob);
  await downloadFile(url, fileName || fileUrl.substring(fileUrl.lastIndexOf('/') + 1));
  window.URL.revokeObjectURL(url);
};
